import classNames from "classnames";
import CustomizeCookiesModal from "components/v2/Modals/CustomizeCookiesModal";
import JSCookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { cookieExpiry, cookies } from "../../../config/index";
import SVGIcon from "../Images/SVGIcon";
import commonStyles from "../style.module.css";
import CookiesContent from "./CookiesContent";
import style from "./style.module.css";

const Cookies = () => {
  const location = useLocation();
  const [showCookiePopup, setShowCookiePopup] = useState(false);
  const [customizeCookieIsOpen, setCustomizeCookieIsOpen] = useState(false);
  const [cookiePreferences, setCookiePreferences] = useState({
    necessary: true,
    functional: true,
    analytics: true,
    performance: true,
    others: false,
  });

  document.cookie = "testcookie=true; Secure; SameSite=Lax";

  function areCookiesEnabled() {
    var cookieEnabled = document.cookie.indexOf("testcookie") !== 1;

    return cookieEnabled;
  }

  useEffect(() => {
    if (!areCookiesEnabled()) {
      alert(
        "Cookies are required for the proper functioning of this website. Please enable cookies in your browser settings and refresh the page.",
      );
    }
  }, []);

  useEffect(() => {
    if (!JSCookies.get("cookiesOptions")) {
      setTimeout(() => {
        setShowCookiePopup(true);
      }, 2000);
    }
  }, [location.pathname]);

  const handleCustomizeCookie = () => {
    try {
      setShowCookiePopup(false);
      setCustomizeCookieIsOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRejectCookie = () => {
    try {
      const cookieOptions = {
        necessary: true,
        functional: false,
        analytics: false,
        performance: true,
        others: false,
      };

      JSCookies.set("cookiesOptions", JSON.stringify(cookieOptions), cookieExpiry);
      setShowCookiePopup(false);
      setCustomizeCookieIsOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAcceptAllCookie = () => {
    try {
      const cookieOptions = {
        necessary: true,
        functional: true,
        analytics: true,
        performance: true,
        others: true,
      };

      JSCookies.set("cookiesOptions", JSON.stringify(cookieOptions), cookieExpiry);
      setShowCookiePopup(false);
      setCustomizeCookieIsOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAcceptCookie = async () => {
    JSCookies.set("cookiesOptions", JSON.stringify(cookiePreferences), cookieExpiry);
    setShowCookiePopup(false);
    setCustomizeCookieIsOpen(false);
  };

  const onCloseModal = () => {
    try {
      setShowCookiePopup(true);
      setCustomizeCookieIsOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const onToggleChange = (e, title) => {
    if (title === "Analytics") {
      setCookiePreferences({
        ...cookiePreferences,
        analytics: e,
      });
    } else if (title === "Others") {
      setCookiePreferences({
        ...cookiePreferences,
        others: e,
      });
    } else {
      setCookiePreferences({
        ...cookiePreferences,
        functional: e,
      });
    }
  };

  return (
    <>
      <Outlet />
      {showCookiePopup ? (
        <div className={style.container}>
          <div className={style.header}>
            <div className={style.headerIcon}>
              <SVGIcon src={"components/v2/Cookies/cookies.svg"} className={style.icon} />
            </div>
            <div className={style.headerText}>We value your privacy</div>
          </div>
          <div className={classNames(style.cookiesContent, commonStyles.scrollBar)}>
            We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our
            traffic. By clicking “Accept All”, you consent to our use of cookies.
          </div>
          <div className={style.cookiesActions}>
            <button
              className={classNames(style.cookiesButton, commonStyles.tertiaryButton)}
              onClick={handleCustomizeCookie}
            >
              Customize
            </button>
            <button
              className={classNames(style.cookiesButton, commonStyles.tertiaryButton)}
              onClick={handleRejectCookie}
            >
              Reject All
            </button>
            <button
              className={classNames(style.cookiesButton, commonStyles.primaryButton)}
              onClick={handleAcceptAllCookie}
              data-testid="Cookies-button-AcceptAll"
            >
              Accept All
            </button>
          </div>
        </div>
      ) : (
        <div className={style.cookiesDetails}>
          <CustomizeCookiesModal
            openModal={customizeCookieIsOpen}
            onCloseModal={onCloseModal}
            handleAcceptAllCookie={handleAcceptAllCookie}
            handleAcceptCookie={handleAcceptCookie}
            handleRejectCookie={handleRejectCookie}
            contentComponent={
              <CookiesContent onToggleChange={onToggleChange} cookies={cookies} cookiePreferences={cookiePreferences} />
            }
          />
        </div>
      )}
    </>
  );
};

export default Cookies;
